/**
 * A property is ignored if it is not set.
 * A property is true if one is true and all others are true or undefined.
 * A property is false if at least one state change is false.
 */
export const applyBooleanProperty = (accumulator, current, property) => {
    const currentValue = current[property];
    if (currentValue === undefined) {
        return;
    }
    accumulator[property] = accumulator[property] === false
        ? false
        : currentValue;
};
export const reducePlayerState = (stateChange) => {
    return stateChange.reduce((acc, state) => {
        applyBooleanProperty(acc, state, 'canSeekForward');
        applyBooleanProperty(acc, state, 'canSeekBackward');
        applyBooleanProperty(acc, state, 'canPause');
        if (state.seekableRange !== undefined) {
            acc.seekableRange = state.seekableRange;
        }
        return acc;
    }, {});
};
